export default __webpack_public_path__ + "static/media/error.fb303d90.png";